module.exports = __webpack_public_path__ + "img/main.1bf19c33.jpg";